import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",

        backgroundColor: "#f5f5f5",
        color: "#666",
        textAlign: "center",
        fontSize: "14px",
      }}
    >
      {/* <span>
        Copyright © {new Date().getFullYear()} by{" "}
        <Link
          to="/dashboard"
          title="OneNight"
          style={{ textDecoration: "none", color: "#963F02" }}
        >
          MMM
        </Link>
        . All rights reserved.
      </span> */}
    </footer>
  );
};

export default Footer;
